import { useSnackbar } from 'notistack'
import { useRecoilState } from 'recoil'
import styled from 'styled-components'

import { usePostRefundPayment } from '~/features/payment/queries/usePayment'
import Close from '~/shared/assets/icons/Close'
import Button from '~/shared/components/buttons/Button'
import { isModalOpenState, selectedRefundIdState } from '~/shared/states'
import theme from '~/shared/styles/theme'

function PaymentCancelModal() {
  const [_, setIsModalOpen] = useRecoilState(isModalOpenState)
  const [selectedRefundId] = useRecoilState(selectedRefundIdState)
  const { mutate: paymentRefund } = usePostRefundPayment()

  const { enqueueSnackbar } = useSnackbar()

  const refundPayment = () => {
    paymentRefund(selectedRefundId, {
      onSuccess: (res) => {
        if (res.errorCode < 0) {
          enqueueSnackbar(res.errorMsg, { variant: 'error' })
        } else if (res.errorCode === 0) {
          setIsModalOpen({
            contents: 'payment-cancel-completed',
            isOpen: true,
          })
        }
      },
      onError: () => {
        setIsModalOpen({
          contents: 'no-refund',
          isOpen: true,
        })
      },
    })
  }

  return (
    <Wrapper onClick={(e) => e.stopPropagation()}>
      <CloseIcon
        onClick={() => setIsModalOpen({ contents: '', isOpen: false })}
      />
      <Title>
        구매하신 티켓을 <br />
        취소하시겠습니까?
      </Title>
      <Desc>
        결제 취소 요청을 하시기전에 결제 취소 및 환불 규정을 잘 읽어봐주세요.{' '}
        <br />
        그래도 진행하시겠습니까?
      </Desc>

      <CancelButton
        $width={92}
        $height={52}
        $fontSize={18}
        $variant="black"
        onClick={refundPayment}
      >
        결제 취소하기
      </CancelButton>
    </Wrapper>
  )
}

export default PaymentCancelModal
const Wrapper = styled.section`
  position: fixed;
  z-index: ${theme.zIndex.modal};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  gap: 36px;
  align-items: center;

  box-sizing: border-box;
  min-width: 30%;
  height: auto;
  margin: 0 auto;
  padding: 108px 77px 60px;

  background-color: ${theme.colors.white};
  border-radius: 12px;

  @media ${theme.device.medium} {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    overflow-y: scroll;

    width: 90%;
    padding: 56px 20px 30px;
  }
`

const CloseIcon = styled(Close)`
  position: absolute;
  top: 36px;
  right: 36px;

  @media ${theme.device.medium} {
    top: 20px;
    right: 20px;
    width: 24px;
    height: 24px;
  }
`

const Title = styled.h1`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 42px;
  font-weight: 500;
  line-height: 60px;
  text-align: center;

  @media ${theme.device.medium} {
    font-size: 36px;
  }
`

const Desc = styled.div`
  font-family: NanumSquareNeo-Regular, sans-serif;
  font-size: 18px;
  line-height: 25px;
  text-align: center;
`

const CancelButton = styled(Button)`
  width: 100%;
  color: ${theme.colors.white};
  background-color: ${theme.colors.grey_5};
`
